import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import cx from 'classnames'

import Line from 'components/Line'
import LinkButton from 'components/LinkButton'

gsap.registerPlugin(ScrollTrigger)

const AboutRecognition = ({ title, text, route, logo: Logo }) => {
  const recognitionRef = useRef(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const start = window.innerWidth < 768 ? 'top 90%' : 'top 80%'
    const end = window.innerWidth < 768 ? 'bottom 10%' : 'bottom 20%'
    gsap.timeline({
      scrollTrigger: {
        trigger: recognitionRef.current,
        start,
        end,
        onEnter: () => {
          if (!isInView) {
            setIsInView(true)
          }
        },
      },
    })
  }, [])

  return (
    <div
      ref={recognitionRef}
      className={cx('recognition --cream', {
        '--in-view': isInView,
      })}
    >
      <div className="recognition-container">
        <div className="recognition-header">
          <Logo />
          <Line hasNoPadding />
          <div>
            <LinkButton route={route} text="Read" newTab />
          </div>
        </div>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  )
}

AboutRecognition.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  route: PropTypes.string,
  logo: PropTypes.func,
}

export default AboutRecognition
